import { useMemo } from 'react';
import cn from 'bem-cn';

import { List, Stack } from '../../../UI';

import { ChallengeCriteria, ChallengeCriteriaType } from './ChallengeCriteria';
import { getChallengeCriterias } from './ChallengeCriterias.constants';
import { ChallengeCriteriasProps } from './ChallengeCriterias.types';
import './ChallengeCriterias.scss';

const b = cn('challenge-criterias');

const renderCriteria = (item: ChallengeCriteriaType) => <ChallengeCriteria {...item} />;
const extractTagKey = (_: ChallengeCriteriaType, index: number) => `criteria-${index}`;

export const ChallengeCriterias = (props: ChallengeCriteriasProps) => {
    const { challengeTitle } = props;

    const criterias = useMemo(() => getChallengeCriterias(challengeTitle), [challengeTitle]);

    return (
        <Stack className={b()}>
            <h2 className={b('title')}>Критерии оценки</h2>
            <List
                direction="row"
                className={b('list')}
                items={criterias}
                renderItem={renderCriteria}
                keyExtractor={extractTagKey}
            />
        </Stack>
    );
};
